export default __webpack_public_path__ + "static/media/logoH.91bc5824.png";